import React from "react";
import FontSizeControl from "./FontSizeControl";

const FontSizeManager = () => {
    const MIN_FONT_SIZE = 8;
    const MAX_FONT_SIZE = 42;

    return (
        <div style={{
            padding: "10px",
            marginTop: `10%`,
            display: `flex`,
            rowGap: `20px`,
            flexDirection: `column`,
        }}>
            <FontSizeControl
                label="Title"
                fontSizeKey={"titleFontSize "}
                defaultFontSize={16}
                minFontSize={MIN_FONT_SIZE}
                maxFontSize={MAX_FONT_SIZE}
            />

            <FontSizeControl
                label="Label"
                fontSizeKey={"labelFontSize "}
                defaultFontSize={16}
                minFontSize={MIN_FONT_SIZE}
                maxFontSize={MAX_FONT_SIZE}
            />
        </div>
    );
};

export default FontSizeManager;
